import script from "./JobsDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./JobsDashboard.vue?vue&type=script&setup=true&lang=js"

import "./JobsDashboard.vue?vue&type=style&index=0&id=0940e560&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0940e560"]])

export default __exports__